// Static data for ImprintNavigationController.vue
// Based on mockup: Product Info is always visible, then accordion steps

/**
 * Get sections configuration based on application type
 * @param {string} applicationType - 'default' | 'calendar' | 'calendar_single'
 * @returns {Array} sections configuration
 */
export function getSections(applicationType = 'default') {
    // For calendar_single: return empty array (Phase 0)
    // Calendar single shows ONLY price matrix, no sections
    if (applicationType === 'calendar_single') {
        console.log('[getSections] Calendar single: returning empty sections array');
        return [];
    }
    
    // Base sections
    const baseSections = [
        {
            id: 'colourQuantity',
            label: `Step 1:  ${getColorName()} & Quantity`,
            meta: null,
            isAlwaysOpen: false,
            isInitiallyOpen: true,
            requiresPrevious: false,
            // Hide for calendar modes
            hidden: applicationType === 'calendar' || applicationType === 'calendar_single',
            description: `Choose a product variety below to enter your desired quantities. You can mix and match different styles to complete your order.`,

        },
        {
            id: 'imprintSelection',
            label: applicationType === 'calendar' || applicationType === 'calendar_single' 
                ? 'Step 1: Customize Your Product'  // Step 1 for calendar
                : 'Step 2: Customize Your Product', // Step 2 for default
            meta: null,
            isAlwaysOpen: false,
            isInitiallyOpen: applicationType === 'calendar' || applicationType === 'calendar_single',
            requiresPrevious: applicationType === 'default',  // Only required for default,
            description: 'section 2 Description '
        },
        {
            id: 'addons',
            label: applicationType === 'calendar' || applicationType === 'calendar_single'
                ? 'Step 2: Add-Ons (Optional)'
                : 'Step 3: Add-Ons (Optional)',
            meta: 'Optional',
            isAlwaysOpen: false,
            isInitiallyOpen: false,
            requiresPrevious: false,
            description: 'section 3 Description ',
        },
        {
            id: 'review',
            label: applicationType === 'calendar' || applicationType === 'calendar_single'
                ? 'Step 2: Review & Add to Cart'
                : 'Step 3: Review & Add to Cart',
            meta: null,
            isAlwaysOpen: false,
            isInitiallyOpen: false,
            requiresPrevious: true,
            description: 'section 4 Description ',
        }
    ];
    
    // Filter out hidden sections
    return baseSections.filter(section => !section.hidden);
}

// Keep static export for backward compatibility
export const IMPRINT_SECTIONS_STATIC = getSections('default');

// Calendar sections presets
export const IMPRINT_SECTIONS_CALENDAR = getSections('calendar');
export const IMPRINT_SECTIONS_CALENDAR_SINGLE = getSections('calendar_single');

/**
 * Returns 'Color' or 'Colour' based on the current URL domain.
 * If the URL contains '.ca' — returns the Canadian spelling ('Colour').
 * Otherwise returns the US spelling ('Color').
 * 
 * @param {boolean} lowercase - If true, returns lowercase ('color' / 'colour').
 *                                Default is false — returns capitalized ('Color' / 'Colour').
 * @returns {string} 'Color' | 'color' | 'Colour' | 'colour'
 * 
 * @example
 * getColorName()            // 'Color' or 'Colour'
 * getColorName(true)        // 'color' or 'colour'
 */
export function getColorName(lowercase = false) {
    const hostname = window.location.hostname;
    const isCanada = hostname.includes('.ca') || hostname.includes('-ca') || hostname.includes('ca.');
    const word = isCanada ? 'Colour' : 'Color';

    return lowercase
        ? word.toLowerCase()
        : word;
}
